module.exports = __webpack_public_path__ + "static/media/delete-round.106cccf3.svg";